import { DialogContent, DialogTitle } from "@material-ui/core";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import ClientHelper from "core/ClientHelper";
import { ApproveIcon, DetailIcon } from "core/Icons";
import PropTypes from "prop-types";
import React, { Component } from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import CardComponent from "views/Components/CardComponent";
import CustomerComponent from "views/Components/CustomerComponent";
import { GenericCheckInput, GenericDateInput, GenericDialog, GenericDialogActions, GenericExpansionPanel, GenericGrid, GenericLabel, GenericSelectInput, GenericTextInput, GenericTitle } from "views/Components/Generic";
import GridButton from "views/Components/GridButton";
import LoadingComponent from "views/Components/LoadingComponent";
import ParameterComponent from "views/Components/ParameterComponent";
import { ClearingDirection, ClearingIssuerFlag, ClearingProcessStatus, GridColumnType, PgmCodeType, ProgramCodes } from "views/Constants/Constant.js";
import Dispute from "views/PPaid/Clearing/Dispute/Dispute";
import VisaClearingTransactionDetail from "views/PPaid/Clearing/Visa/TransactionDetails/VisaClearingTransactionDetail";


class VisaClearingTransaction extends Component {
	constructor(props) {
		super(props);

		this.initialModel = {
			Id: 0,
			UniqueClientId: ClientHelper.IsClient() ? ClientHelper.GetClientRowId() : undefined,
			IsMainCard: true,
			ProcessStatusParams: {},
			IssuerFlagParams: {},
			ValidationStatusParams: {},
			DirectionParams: {},
		};

		this.state = {
			transactionmodel: {},
			smsdatamodel: {},
			chipdatamodel: {},
			paymentservicemodel: {},
			disputeModel: {
				ClearingDisputeFeeData: []
			},
			disputeFeeModel: {},
			model: {
				ProcessStatusParams: {},
				IssuerFlagParams: {},
				ValidationStatusParams: {},
				DirectionParams: {}
			},
			list: [],
			DisputeActionData: [],
			isLoading: false,
			isDialogOpen: false,
			isDisputeDialogOpen: false,
			isDisputeActionDialogOpen: false
		}


		this.emptyObject = {};

		this.maxLength26 = { maxLength: 26 };
		this.maxLength19 = { maxLength: 19 };
		this.maxLength12 = { maxLength: 12 };
		this.maxLength40 = { maxLength: 40 };

		this.parameterUniqueClientId = {
			UniqueClientId: ClientHelper.IsClient() ? ClientHelper.GetClientId() : undefined
		};

		this.renderItemUniqueClient = {};

		this.parameterProduct = {};

		this.Columns = [
			{
				Header: "Actions",
				accessor: "Actions",
				sortable: false,
				filterable: false,
				width: 100
			},

			{
				Header: "Issuer Acquirer Flag",
				accessor: "IssuerAcqueirerFlag"
			},
			{
				Header: "Card Number",
				accessor: "CardNumber"
			},
			{
				Header: "Original Amount",
				accessor: "OrginalAmount",
				type: GridColumnType.Money

			},
			{
				Header: "Settlement Amount",
				accessor: "SettlementAmount",
				type: GridColumnType.Money

			},
			{
				Header: "Direction",
				accessor: "Direction"
			},
			{
				Header: "Clearing Date",
				accessor: "ClearingDate",
				type: GridColumnType.DateTime

			},
			{
				Header: "Validation Status",
				accessor: "ValidationStatus"
			},
			{
				Header: "Arn",
				accessor: "ARN"
			},


		];


	}

	componentDidMount() {
		this.props.setAppLeftTitle("Clearing Transaction");
		this.props.setAppCenterTitle("PREPAID CARD MANAGEMENT");
	}

	HandleChange = (name, newValue, data) => {
		const model = { ...this.state.model };
		if (name === "UniqueClientId") {
			delete model.ClientCustomerId;
			delete model.CustomerNumber;
			delete model.CardId;
			delete model.CardTokenNumber;
		}
		if (name === "Customer") {
			if (newValue) {
				model.ClientCustomerId = newValue.Id;
				model.CustomerNumber = newValue.CustomerNumber;
			} else {
				delete model.ClientCustomerId;
				delete model.CustomerNumber;
				delete model.CardId;
				delete model.CardTokenNumber;
			}
		}
		if (name === "Card") {
			if (newValue) {
				model.CardId = newValue.CardId;
				model.CardTokenNumber = newValue.CardTokenNumber;
			} else {
				delete model.CardId;
				delete model.CardTokenNumber;
			}
		}
		model[name] = newValue;
		this.setState({ model });
	}

	FillCustomer = (customer) => {
		this.HandleChange("Customer", customer);
	}

	FillCard = (card) => {
		this.HandleChange("Card", card);
	}

	HandleClear = () => {
		this.setState({ model: { ...this.initialModel }, isEdit: false, index: -1 });
	}

	HandleSearch = () => {
		const model = { ...this.state.model };
		this.setState({ isLoading: true });
		Proxy.POST
			(
				"/prepaidapi/v1.0/VisaClearingTransaction/GetAllVisaTransaction",
				model,
				(responseData) => {
					this.setState({ isLoading: false });
					if (!responseData.IsSucceeded) {
						this.props.showMessage("error", "Error", responseData.ErrorDescription);
						return;
					}
					if (responseData.Item !== null) {
						this.setState({
							list:
								responseData.Item.map(x => {
									return {
										Actions: (
											<div>
												<GridButton
													tooltip="Detail"
													Icon={DetailIcon}
													OnClick={() => {
														this.setState({
															isDialogOpen: true,
															transactionmodel: x.VisaClearingTransaction,
															chipdatamodel: x.VisaChipData,
															paymentservicemodel: x.VisaPaymentServiceData,
															smsdatamodel: x.VisaSmsData
														})
													}} />
												<GridButton
													tooltip="Dispute"
													Icon={ApproveIcon}
													OnClick={() => { this.HandleGetDispute(x.VisaClearingTransaction) }} />

											</div>
										),
										IssuerAcqueirerFlag: x.IssuerAcqueirerFlag == null || undefined ? "" : x.IssuerAcqueirerFlag,
										OrginalAmount: x.OrginalAmount == null || undefined ? "" : x.OrginalAmount,
										SettlementAmount: x.SettlementAmount == null || undefined ? "" : x.SettlementAmount,
										RRN: x.RRN == null || undefined ? "" : x.RRN,
										ProcessingCode: x.ProcessingCode == null || undefined ? "" : x.ProcessingCode,
										Direction: x.Direction == null || undefined ? "" : x.Direction,
										ClearingDate: x.ClearingDate == null || undefined ? 0 : x.ClearingDate,
										ValidationStatus: x.ValidationStatus == null || undefined ? 0 : x.ValidationStatus,
										ARN: x.ARN == null || undefined ? 0 : x.ARN,
										ProcessStatusParams: x.ProcessStatusParams == null || undefined ? 0 : x.ProcessStatusParams,
										DirectionParams: x.DirectionParams == null || undefined ? 0 : x.DirectionParams,
										ValidationStatusParams: x.ValidationStatusParams == null || undefined ? 0 : x.ValidationStatusParams,
										IssuerFlagParams: x.IssuerFlagParams == null || undefined ? 0 : x.IssuerFlagParams,
										IsReversal: x.IsReversal == null || undefined ? 0 : x.IsReversal,
										CardNumber: x.CardNumber == null || undefined ? 0 : x.CardNumber

									}
								})
						});
					}

				},
				(error) => {
					this.setState({ isLoading: false });
					this.props.showMessage("error", "Error", error);
				}
			)

	}

	Validate = () => {
		const { model } = this.state;

		if (!model.UniqueClientId) {
			this.props.showMessage("warning", "Client not selected", "Select the Client to continue.");
			return false;
		}

		if (!model.ClientCustomerId) {
			this.props.showMessage("warning", "Customer not selected", "Select the Customer to continue.");
			return false;
		}

		if (!model.ProductId) {
			this.props.showMessage("warning", "Product not selected", "Select the Product to continue.");
			return false;
		}

		if (!model.EmbossName) {
			this.props.showMessage("warning", "Emboss Name is empty", "Enter the Emboss Name to continue.");
			return false;
		}

		if (!model.CardIssuingReasonType) {
			this.props.showMessage("warning", "Issuing Resason Type is empty", "Enter the Issuin Reason Type to continue.");
			return false;
		}

		return true;
	}

	RenderItemUniqueClient = (d) => {
		this.renderItemUniqueClient = `${d.UniqueClientId} - ${d.Name}`;
		return this.renderItemUniqueClient;
	}

	RowSelected = (index) => {
		let { list } = this.state;
		const tempModel = list[index];
		if (list[index].CardRequestId) {
			tempModel.Id = list[index].Id;
		}
		this.setState({ isEdit: true, model: tempModel, index });
	}

	GetProductParameter = () => {
		this.parameterProduct.UniqueClientId = this.state.model.UniqueClientId;
		this.parameterProduct.IsNoNameProduct = false;
		return this.parameterProduct;
	}

	
	TransactionModelChange = (modelFunction) => {
		this.setState(function (state, props) {
			var model = state.transactionmodel || {};

			if (modelFunction)
				model = modelFunction(model);

			return { transactionmodel: model };
		});
	}

	DialogModelChange = (modelFunction) => {
		this.setState(function (state, props) {
			var model = state.initialModel || {};

			if (modelFunction)
				model = modelFunction(model);

			return { initialModel: model };
		});
	}
	CancelSelectCallback = () => {
		this.setState({
			isDialogOpen: false,
			isDisputeDialogOpen: false
		});
	};
	HandleClickUpdate = () => {
		this.setState({ isLoading: true });
		Proxy.POST("/prepaidapi/v1.0/VisaClearingTransaction/Update",
			{
				VisaClearingTransaction: this.state.transactionmodel,
				VisaSmsData: this.state.smsdatamodel,
				VisaChipData: this.state.chipdatamodel,
				VisaPaymentServiceData: this.state.paymentservicemodel
			},
			responseData => {
				this.setState({ isLoading: false });
				if (responseData.IsSucceeded != false) {
					this.setState({
						isDialogOpen: false
					});
				} else {
					this.props.showMessage("error", "Error", responseData.ErrorDescription);
					this.setState({ dialogData: [] });
				}
			},
			error => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			});
	}

	SmsDataModelChange = (modelFunction) => {
		this.setState(function (state, props) {
			var model = state.smsdatamodel || {};

			if (modelFunction)
				model = modelFunction(model);

			return { smsdatamodel: model };
		});
	}


	PaymentServiceModelChange = (modelFunction) => {
		this.setState(function (state, props) {
			var model = state.paymentservicemodel || {};

			if (modelFunction)
				model = modelFunction(model);

			return { paymentservicemodel: model };
		});
	}

	ChipDataModelChange = (modelFunction) => {
		this.setState(function (state, props) {
			var model = state.chipdatamodel || {};

			if (modelFunction)
				model = modelFunction(model);

			return { chipdatamodel: model };
		});
	}

	DisputeModelChange = (modelFunction) => {
		this.setState(function (state, props) {
			var model = state.disputeModel || {};

			if (modelFunction)
				model = modelFunction(model);

			return { disputeModel: model };
		});
	}

	ReverseControl = () => {
		const { model } = { ...this.state };

		if (model.ProcessStatusParams.ParameterValue != ClearingProcessStatus.ReadyToSend) {
			return true;
		}
		if (model.DirectionParams.ParameterValue != ClearingDirection.Outgoing) {
			return true;
		}
		if (model.IssuerFlagParams.ParameterValue != ClearingIssuerFlag.Acquirer) {
			return true;
		}
		if (model.IsReversal) {
			return true;
		}


		return false;
	}


	HandleClickReverse = () => {
		this.setState({ isLoading: true });
		Proxy.POST("/prepaidapi/v1.0/VisaClearingTransaction/VisaClearingTransactionReverse",
			this.state.detailModel,
			responseData => {
				this.setState({ isLoading: false });
				if (responseData.IsSucceeded != false) {

					this.setState({
						isDialogOpen: false
					});
				} else {
					this.props.showMessage("error", "Error", responseData.ErrorDescription);

				}
			},
			error => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			});
	}



	ValidateDispute = () => {

		const model = this.state.disputeModel;

		if (model.ChargebackStatusId) {
			if (!model.ChargebackReasonCodeId) {
				this.props.showMessage("error", "Chargeback", "Chargeback Reason Code can not be empty");
				return false;
			}
		}

		// if (model.RetrievalResponseStatusId) {
		// 	if (!model.RetrievalResponseReasonCodeId) {
		// 		this.props.showMessage("error", "Retrieval Response", "Retrieval Response Reason Code can not be empty");
		// 		return false;
		// 	}
		// }

		if (model.RepresentmentStatusId) {
			if (model.ChargebackStatusId) {
				this.props.showMessage("error", "Charge Back", "Chargeback information can not be empty");
				return false;
			}
			if (!model.RepresentmentReasonCodeId) {
				this.props.showMessage("error", "Representment", "Representment Reason Code can not be empty");
				return false;
			}
		}


		if (model.SecondChargebackStatusId) {
			if (!model.RepresentmentStatusId) {
				this.props.showMessage("error", "Retrieval Response", "Representment information can not be empty");
				return false;
			}
			if (model.SecondChargebackReasonCodeId) {
				this.props.showMessage("error", "Retrieval Response", "Second Chargeback Reason Code  can not be empty");
				return false;
			}
		}
		return true;
	}

	HandleClickDispute = () => {
		if (!this.ValidateDispute()) return false;

		this.state.disputeModel.PgmCode = PgmCodeType.Visa;
		this.setState({ isLoading: true });
		Proxy.POST("/prepaidapi/v1.0/ClearingDispute/InsertOrUpdateClearingDispute",
			this.state.disputeModel,
			responseData => {
				this.setState({ isLoading: false });
				if (responseData.IsSucceeded != false) {
					this.CancelSelectCallback();
				} else {
					this.props.showMessage("error", "Error", responseData.ErrorDescription);
				}
			},
			error => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			});
	}


	HandleDisputeAction = () => {
		this.setState({ isLoading: true });

		Proxy.POST("/prepaidapi/v1.0/ClearingDispute/GetDisputeAction",
			{
				DisputeId: this.state.disputeModel.Id
			},
			responseData => {
				this.setState({ isLoading: false });
				if (responseData.IsSucceeded != false) {
					this.setState({ isDisputeActionDialogOpen: true, DisputeActionData: responseData.Item });
				}
				else {
					this.setState({ isDisputeActionDialogOpen: false });
					this.props.showMessage("error", "Error", responseData.ErrorDescription);
				}
			},
			error => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			});
	}

	HandleGetDispute = (model) => {
		this.setState({ isLoading: true });
		Proxy.POST("/prepaidapi/v1.0/ClearingDispute/GetDisputeByTransactionId",
			{
				ClearingDataTableId: model.Id,
				PgmCode: PgmCodeType.Visa
			},
			responseData => {
				this.setState({ isLoading: false });
				if (responseData.IsSucceeded != false) {
					this.setState({ isDisputeDialogOpen: true, disputeModel: responseData.Item });
				}
				else {
					this.setState({ isDisputeDialogOpen: false });
					this.props.showMessage("error", "Error", responseData.ErrorDescription);
				}
			},
			error => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			});
	}

	HandleActionDialogOpen = () => {
		this.HandleDisputeAction();
	}
	HandleActionDialogClose = () => {
		this.setState({ isDisputeActionDialogOpen: false });
	}

	DisputeFeeModelChange = (modelFunction) => {
		this.setState(state => {
			var model = state.disputeFeeModel || {};
			if (modelFunction)
				model = modelFunction(model);
			return { disputeFeeModel: model, disputeModel: this.state.disputeModel };
		});
	}

	DisputeFeeModelDelete = (index) => {
		if (!index) {
			this.state.disputeModel.ClearingDisputeFeeData.splice(index, 1);
		}
		this.setState({ disputeModel: this.state.disputeModel });
	}

	DisputeFeeModelClear = () => {
		this.setState({ disputeFeeModel: {} });
	}

	DisputeFeeModelEdit = (index) => {
		if (!index) {
			this.state.disputeModel.ClearingDisputeFeeData[index] = this.state.disputeFeeModel;
		}
		this.setState({ disputeModel: this.state.disputeModel });
	}


	DisputeFeeModelPush = (modelFunction) => {
		var model = this.state.disputeFeeModel || {};
		var arr = this.state.disputeModel.ClearingDisputeFeeData || [];
		arr.push({ ...model });
		this.state.disputeModel.ClearingDisputeFeeData = arr;
		this.setState({ disputeModel: this.state.disputeModel });
	}



	render() {
		const {  Disabled } = this.props;
		const { alert, model, list, isLoading } = this.state;

		var IsClient = ClientHelper.IsClient();

		return (
			<div>
				<LoadingComponent Show={isLoading} />
				{alert}
				<ButtonToolbar ButtonList={[
					{ Code: "Search", OnClick: this.HandleSearch, Disabled: Disabled },
					{ Code: "Clear", OnClick: this.HandleClear, Disabled: Disabled },

				]} menuId={this.props.menuId} ApprovalData={this.props.ApprovalData} After={this.props.After} />

				<GenericDialog open={this.state.isDialogOpen} onBackdropClick={this.CancelSelectCallback} maxWidth="xl" fullWidth keepMounted={true} style={{ zIndex: 8 }} >
					<DialogTitle><GenericLabel FontSize="16px" Text="Detail" Bold={true} />
					</DialogTitle>

					<DialogContent style={{ marginTop: 8 }}>
						<VisaClearingTransactionDetail
							transactionmodel={this.state.transactionmodel}
							smsdatamodel={this.state.smsdatamodel}
							chipdatamodel={this.state.chipdatamodel}
							paymentservicemodel={this.state.paymentservicemodel}
							initialModel={this.state.initialModel}
							onModelChange={this.TransactionModelChange}
							onSmsDataChange={this.SmsDataModelChange}
							onPaymentServiceModelChange={this.PaymentServiceModelChange}
							onChipDataModelChange={this.ChipDataModelChange}
						/>
					</DialogContent>
					<GenericDialogActions>
						<Button size="sm" onClick={this.HandleClickUpdate}>Update</Button>
						<Button size="sm" onClick={this.HandleClickReverse} disabled={this.ReverseControl()}>Reverse</Button>
						<Button size="sm" onClick={this.CancelSelectCallback}>Cancel</Button>
					</GenericDialogActions>
				</GenericDialog>

				<GenericDialog open={this.state.isDisputeDialogOpen} onBackdropClick={this.CancelSelectCallback} maxWidth="xl" fullWidth keepMounted={true} style={{ zIndex: 8 }} >
					<DialogTitle>
						<GenericLabel FontSize="16px" Text="Dispute" Bold={true} />
					</DialogTitle>
					<DialogContent style={{ marginTop: 8 }}>
						{this.state.isDisputeDialogOpen &&
							<Dispute
								showMessage={this.props.showMessage}
								PgmCode={PgmCodeType.Visa}

								model={this.state.disputeModel}
								disputeFeeModel={this.state.disputeFeeModel}

								ActionData={this.state.DisputeActionData}
								isActionDialogOpen={this.state.isDisputeActionDialogOpen}

								onModelChange={this.DisputeModelChange}
								onFeeModelPush={this.DisputeFeeModelPush}
								onFeeModelChange={this.DisputeFeeModelChange}
								onFeeModelDelete={this.DisputeFeeModelDelete}
								onFeeModelClear={this.DisputeFeeModelClear}
								onFeeModelEdit={this.DisputeFeeModelEdit}
								onActionsList={this.HandleDisputeAction}
								onActionModelClose={this.HandleActionDialogClose}

							/>
						}
					</DialogContent>
					<GenericDialogActions>
						<Button size="sm" onClick={this.CancelSelectCallback}>Cancel</Button>
						<Button size="sm" onClick={this.HandleClickDispute}>Submit</Button>
						<Button size="sm" onClick={this.HandleActionDialogOpen}>Actions</Button>
					</GenericDialogActions>
				</GenericDialog>



				<GridContainer>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel Title="Main Panel">
									<GridContainer>
										<GridItem xs={12}>
											<GridContainer>

												<GridItem xs={4}>
													<ParameterComponent
														Name="IssuerAcquirerFlagId"
														LabelText="Issuer Acquirer Flag"
														ParameterCode="IssuerAcquirerFlag"
														Value={model.IssuerAcquirerFlagId}
														ValueChanged={this.HandleChange}
														Disabled={false}
													/>
												</GridItem>
												<GridItem xs={4}>
													<ParameterComponent
														Name="DirectionId"
														LabelText="Direction"
														ParameterCode="Direction"
														Value={model.DirectionId}
														ValueChanged={this.HandleChange}
														Disabled={false}
													/>
												</GridItem>
												<GridItem xs={4}>
													<ParameterComponent
														Name="ValidationStatusId"
														LabelText="Validation Status"
														ParameterCode="ValidationStatus"
														Value={model.ValidationStatusId}
														ValueChanged={this.HandleChange}
														Disabled={false}
													/>
												</GridItem>


											</GridContainer>
											<GridContainer>
												<GridItem xs={4}>
													<GenericSelectInput
														Name="UniqueClientId"
														LabelText="Client"
														Method="POST"
														Url="/bankapi/v1.0/BankCustomer/Search"
														Parameter={this.parameterUniqueClientId}
														DataRoot="Item"
														KeyValueMember="Id"
														RenderItem={this.RenderItemUniqueClient}
														Value={model.UniqueClientId}
														ValueChanged={this.HandleChange}
														CanClear
														Disabled={IsClient}
														DefaultIndex={IsClient ? 0 : -1} />
												</GridItem>
												<GridItem xs={4}>
													<CustomerComponent
														key={model.UniqueClientId}
														LabelMd={4}
														CustomerNumber={model.CustomerNumber}
														HandleChange={this.HandleChange}
														FillCallback={this.FillCustomer}
														Programs={[ProgramCodes.Prepaid]}
														UniqueClientId={model.UniqueClientId}
														Disabled={!model.UniqueClientId}
													// Required
													// IsInvalid={vModel.ClientCustomerId}
													/>
												</GridItem>
												<GridItem xs={4}>
													<CardComponent
														key={"Card_" + [model.UniqueClientId, model.ClientCustomerId]}
														LabelMd={4}
														CardTokenNumber={model.CardTokenNumber}
														HandleChange={this.HandleChange}
														FillCallback={this.FillCard}
														ClientCustomerId={model.ClientCustomerId}
														UniqueClientId={model.UniqueClientId}
														Disabled={!model.ClientCustomerId}
													// Required
													// IsInvalid={vModel.CardId}
													/>
												</GridItem>
											</GridContainer>

											<GridContainer>
												<GridItem xs={4}>

													<GenericCheckInput
														Name="IsReversal"
														LabelText="Is Reversal"
														Value={model.IsReversal}
														ValueChanged={this.HandleChange}
													/>

												</GridItem>
												<GridItem xs={4}>
													<GenericDateInput
														Name="ClearingDate"
														LabelText="Clearing Date"
														Value={model.ClearingDate}
														ValueChanged={this.HandleChange}
														Disabled={false} />
												</GridItem>
												<GridItem xs={4}>
													<GenericTextInput
														Name="ARN"
														LabelMd={4}
														LabelText="ARN"
														Format={"(@) (@@@@@@) (@@@@) (@@@@@@@@@@@) (@)"}
														inputProps={this.maxLength40}
														Value={model.ARN}
														ValueChanged={this.HandleChange} />
												</GridItem>

											</GridContainer>
										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
				<GridContainer>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardHeader>
								<GenericTitle text={"Visa Clearing List"} />
							</CardHeader>
							<CardBody>
								<GridContainer spacing={16}>
									<GridItem xs={12}>
										<GenericGrid
											Data={list}
											Columns={this.Columns}
										/>
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div >
		);
	}
}

VisaClearingTransaction.propTypes = {
	classes: PropTypes.object,
	Disabled: PropTypes.bool
};

export default withArtifex(VisaClearingTransaction, {});